import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';
import { faqs } from '../data/mock';

const FAQ = () => {
  return (
    <section className="py-24 lg:py-32 bg-white">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20">
          {/* Left Column - Header */}
          <div>
            <span className="label-text text-[rgba(35,35,35,0.5)] mb-4 block">Questions</span>
            <h2 className="section-title mb-6">FAQ</h2>
            <p className="font-body text-lg text-[rgba(35,35,35,0.7)] leading-relaxed">
              Common questions about my data analysis services and workflow. Feel free to reach out if you have other questions.
            </p>
          </div>

          {/* Right Column - Accordion */}
          <div>
            <Accordion type="single" collapsible className="w-full">
              {faqs.map((faq, idx) => (
                <AccordionItem key={idx} value={`item-${idx}`} className="border-b border-[rgba(35,35,35,0.1)]">
                  <AccordionTrigger className="font-display text-left font-semibold py-6 hover:no-underline hover:text-[#38FF62] transition-colors">
                    {faq.question}
                  </AccordionTrigger>
                  <AccordionContent className="font-body text-[rgba(35,35,35,0.7)] pb-6">
                    {faq.answer}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;